<template>
  <div class="select-dict-tree">
    <el-tree
      ref="this.$refs.dictListTree"
      :node-key="nodeKey"
      :indent="10"
      :data="treeData"
      :props="treeProps"
      :check-strictly="true"
      show-checkbox
      highlight-current
      :render-after-expand="false"
      :disabled="selectable"
      @check-change="handleNodeCheck"
      @node-click="handleNodeClick"
    />
  </div>
</template>

<script>
export default {
  name: 'LSelectDictTree',
  props: {
    dict: {
      type: Object,
      default() {
        return null;
      }
    },
    selections: {
      type: Array,
      default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pageData: null,
      treeData: [],
      nodeKey: "dictItemCode",
      treeProps: {
        value: "dictItemCode",
        label: "dictItemName",
        children: "children",
        disabled: (node) => {
          return this.selectable(node);
        }
      }
    }
  },
  watch: {
    dict: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.pageData = newValue;
          this.tableData = this.pageData.items;
        }
      }
    },
  },
  methods: {
    /*设置树节点能否选择*/
    selectable(node) {
      return this.selections.find((item) => item[this.nodeKey] === node[this.nodeKey]);
    },

    /*点击checkbox(单选)*/
    handleNodeCheck(data, checked) {
      if (checked && !this.multiple) {
        (this.$refs.dictListTree)?.setCheckedNodes([data]);
        this.$nextTick(() => {
          const nodes = (this.$refs.dictListTree)?.getCheckedNodes();
          this.$emit("single", nodes);
        });
      }
    },

    /*树点击行*/
    handleNodeClick(node) {
      this.$emit("node-click", node);
    },

    /*树获取选中*/
    getCheckedNodes() {
      return this.$refs.dictListTree.getCheckedNodes();
    },

    /*树设置选中/取消选中*/
    setChecked(data, checked) {
      this.$refs.dictListTree.setChecked(data, checked);
    }
  }
}
</script>

<style lang="scss" scoped>
.select-dict-tree {
  width: 100%;
  height: 100%;
  padding: 6px 3px;
  box-sizing: border-box;
}
</style>
